const PROPOSAL_REVIEW_FORM_KEYS = new Set([
  'analisis-aprobacion-propuesta',
  'analisis-negociacion-propuesta-c',
  'analisis-negociacion-propuesta-dg',
]);

export function getCommercialApprovalHistoricSchemaDependencies(formKey: string): string[] {
  return PROPOSAL_REVIEW_FORM_KEYS.has(formKey) ? ['alta-aprobacion-comercial'] : [];
}

export function getCommercialApprovalHistoricAdditionalVariableNames(formKey: string): string[] {
  return PROPOSAL_REVIEW_FORM_KEYS.has(formKey) ? ['historialChat'] : [];
}
